import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { thousandSeparator } from "../utils/utils";

const { Select2, Date, DateTime, Text } = Inputs;

function PromosList({ history, match }) {
  const dispatch = useDispatch();

  const modelPromos = useSelector((state) => state.getPromos);
  const modelDelete = useSelector((state) => state.deletePromo);

  const [promos, setPromos] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const data = modelDelete?.data?.data;
    const error = modelDelete?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckDeletePromo.actions.clear());
    }
    if (data) {
      handlePage(0)

      dispatch(controller.duckDeletePromo.actions.clear());
    }
  }, [modelDelete]);

  useEffect(() => {
    const data = modelPromos?.data?.data;
    const error = modelPromos?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckGetPromos.actions.clear());
    }
    if (data) {
     
      setPromos(data.data.items);
      setTotalResults(data.data.total);

      dispatch(controller.duckGetPromos.actions.clear());
    }
  }, [modelPromos]);

  useEffect(() => {
    const data = {
      page: 1,
      limit: pageSize,
      localId: match.params.localId,
    };
    dispatch(controller.getPromosThunk(data));
  }, []);

  function handlePage(page) {
    setActivePage(page);
    setPromos([]);
    const data = {
      page: page + 1,
      limit: pageSize,
      localId: match.params.localId,
    };
    dispatch(controller.getPromosThunk(data));
  }

  function deletePromo(id) {

    const data = {
      id: id
    };
    dispatch(controller.deletePromoThunk(data));
  }

  return (
    <Content
      title="Promos"
      subTitle="Promos"
      browserTitle="Promos"
      show={false}
    >
      <Row>
        <Col md="10" mdOffset="1">
          <Box title="Promos">
            <Button
              type="primary"
              text="Agregar"
              pullRight={true}
              onClick={() => history.push(`/addPromo/${match.params.localId}`)}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
            {promos && promos.length > 0 ? (
              <SimpleTable
                hover={true}
                data={promos.map((row, index) => {
                  return {
                    nombre: row.nombre,
                    servicio: row.servicioNombre,
                    fechaInicio: moment(row.fechaInicio).format("YYYY-MM-DD"),
                    fechaFin: moment(row.fechaFin).format("YYYY-MM-DD"),
                    precio: thousandSeparator(row.precio),
                    eliminar:(<Button
                      type="danger"
                      text="Eliminar"
                      onClick={() =>
                        deletePromo(row._id)
                      }
                    />),
                  };
                })}
                columns={[
                  { title: "Nombre", data: "nombre" },
                  { title: "Servicio", data: "servicio" },
                  { title: "Inicio", data: "fechaInicio" },
                  { title: "Fin", data: "fechaFin" },
                  { title: "Precio", data: "precio" },
                  { title: "Accion", data: "eliminar" },
                ]}
              />
            ) : (
              <h4>No se han encontrado promos</h4>
            )}
            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default PromosList;
